import { Component, Input, OnInit } from '@angular/core';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { GamificationService } from '../services/gamification.service';

@Component({
  selector: '',
  template: '',
})
export class GamificationResultHandler extends BaseSearchComponent<GamificationService> implements OnInit {
  fullPath;
  labelKey;
  public searchName: string;
  headers = [];
  filteredData = [];
  constructor(
    public service: GamificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, router, headerService);
    // this.searchName = 'SearchGamification';
  }

  ngOnInit() {
    let requestSeq = this.route.snapshot.paramMap.get('id');
    const pathSegments = this.route.snapshot.url;
    this.fullPath = pathSegments.map((segment) => segment.path).join('/');
    const inputLabel = this.fullPath.split('-')[0];
    this.labelKey = inputLabel.charAt(0).toUpperCase() + inputLabel.slice(1);
    this.getBreadCrumbList();
    this.getSearchList(requestSeq);
    super.ngOnInit();
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: this.labelKey + ' ' + this.settingService.getLabelValue('gamificationInquiry'),
        link: '/' + this.labelKey.toLowerCase() + '-inquiry',
      },
      {
        id: this.labelKey + ' ' + this.settingService.getLabelValue('gamificationResult'),
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.labelKey + ' ' + this.settingService.getLabelValue('gamificationResult');
    return header;
  }

  getSearchList(requestSeq) {
    this.service.getEvaluationDetails(requestSeq).subscribe((data) => {
      let dataLog = JSON.parse(JSON.stringify(data));
      if (dataLog && dataLog.data && dataLog.data.Entity) {
        const recordId = dataLog.data.Entity.evaluationId;
        if (recordId) {
          dataLog.data.Entity.link = `/contest-and-incentive-details/${recordId}`;
        } else {
          dataLog.data.Entity.link = null;
        }
        this.filteredData.push(dataLog.data.Entity);
      }
    });
  }
}
